module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.dialogVisible,
      "size": "small",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "销售下单号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "销售下单时间"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderTime))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "代理商"
    }
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.OrderData.AgentCode) + " " + _vm._s(_vm.OrderData.AgentName) + " " + _vm._s(_vm.OrderData.AgentAddress) + " " + _vm._s(_vm.OrderData.AgentTel))])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "项目"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.ProjectTypeName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "业务员"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.SaleEmployeeName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合同款"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.TotalPrice))])]), _vm._v(" "), (_vm.isReadOnly) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "审核状态"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderStatusName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "审核时间"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.AuditTime))])])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "凭证"
    }
  }, [_c('div', {
    staticClass: "show-img-ctn uclear"
  }, [_vm._l((_vm.OrderData.VoucherPic), function(item, index) {
    return [_c('div', {
      staticClass: "show-img-cell",
      on: {
        "click": function($event) {
          _vm.LookPicture(item.Url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": item.Name,
        "src": item.Url
      }
    })])]
  })], 2)]), _vm._v(" "), (_vm.isReadOnly && _vm.OrderData.OrderStatus == 11) ? _c('el-form-item', {
    attrs: {
      "label": "审核意见"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.auditFormData.AuditRemark))])]) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(!_vm.isReadOnly) ? _c('el-form-item', {
    attrs: {
      "label": "审核结果"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.chooseType
    },
    model: {
      value: (_vm.auditFormData.OrderStatus),
      callback: function($$v) {
        _vm.$set(_vm.auditFormData, "OrderStatus", $$v)
      },
      expression: "auditFormData.OrderStatus"
    }
  }, _vm._l((_vm.status), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isShowAuditRemark && !_vm.isReadOnly) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "审核意见"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.auditFormData.AuditRemark),
      callback: function($$v) {
        _vm.$set(_vm.auditFormData, "AuditRemark", $$v)
      },
      expression: "auditFormData.AuditRemark"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.dialogClose
    }
  }, [_vm._v("关闭")]), _vm._v(" "), (!_vm.isReadOnly) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定")]) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-204fd9b8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Order/voucherAudit/components/paymentAuditOrder/index.vue
// module id = 1412
// module chunks = 1